import { SkeletonItem, Skeleton, Title3, Button, Label, tokens, Caption1, ProgressBar, Field, Caption2, Badge, Subtitle2, Card } from "@fluentui/react-components";
import { createElement } from "react";
import React from "react";
import { comparePrimitives, safeHash, equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, tryHead, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { sortBy, map as map_1, append as append_1, sumBy, contains, collect } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { ArrowRightRegular, BookOpenRegular, LayerRegular } from "@fluentui/react-icons";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "../Context.jsx";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Track, toastServerError, Task } from "../ApiClient.jsx";
import { errorToast } from "../Toasts.jsx";
import { CreateTrackDialog } from "./CreateTrack.jsx";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";

function TrackCard(track, completedTasks) {
    let elems_6, elems_5, children, el_25, el_23;
    const el_27 = Card;
    return createElement(el_27, createObj(ofArray([["style", {
        width: 100 + "%",
        minHeight: 128,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
        maxWidth: 750,
    }], (elems_5 = toList(delay(() => {
        let elems, el, el_6;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 25 + "px ",
            alignItems: "center",
        }], (elems = [(el = Subtitle2, createElement(el, {
            children: track.Name,
        })), (el_6 = Badge, createElement(el_6, createObj(toList(delay(() => append(singleton(["appearance", "tint"]), delay(() => (track.Enabled ? append(singleton(["color", "success"]), delay(() => {
            let el_2;
            return singleton(["children", (el_2 = Caption2, createElement(el_2, {
                children: "Publisert",
            }))]);
        })) : append(singleton(["color", "warning"]), delay(() => {
            let el_4;
            return singleton(["children", (el_4 = Caption2, createElement(el_4, {
                children: "Utkast",
            }))]);
        }))))))))))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let el_11, matchValue, el_8;
            let fraction;
            const allTasksInTrack = collect((_arg) => _arg.RequiredTasks, track.TrackLevels);
            const totalCompleted = allTasksInTrack.filter((t) => contains(t, completedTasks, {
                Equals: equals,
                GetHashCode: safeHash,
            }));
            fraction = (totalCompleted.length / allTasksInTrack.length);
            return append(singleton((el_11 = Field, createElement(el_11, {
                style: {
                    width: 300,
                },
                validationMessage: `${~~(fraction * 100)} % fullført`,
                validationState: "none",
                children: (matchValue = tryHead([(el_8 = ProgressBar, createElement(el_8, {
                    thickness: "large",
                    shape: "rounded",
                    color: "brand",
                    value: fraction,
                }))]), (matchValue == null) ? defaultOf() : matchValue),
            }))), delay(() => {
                let el_13;
                return append(singleton((el_13 = Caption1, createElement(el_13, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                    children: track.Description,
                }))), delay(() => {
                    let elems_4, elems_2, el_15, el_17, elems_3, el_19, el_21;
                    return singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        gap: 20 + "px ",
                    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    }], (elems_2 = [(el_15 = LayerRegular, createElement(el_15, {
                        fontSize: 20,
                    })), (el_17 = Label, createElement(el_17, {
                        size: "medium",
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: `${track.TrackLevels.length} nivåer`,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    }], (elems_3 = [(el_19 = BookOpenRegular, createElement(el_19, {
                        fontSize: 20,
                    })), (el_21 = Label, createElement(el_21, {
                        size: "medium",
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: `${sumBy((_arg_1) => _arg_1.TrackLevelCourses.length, track.TrackLevels, {
                            GetZero: () => 0,
                            Add: (x_1, y_1) => (x_1 + y_1),
                        })} kurs`,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), (children = singleton_1((el_25 = Button, createElement(el_25, {
        onClick: (_arg_2) => {
            RouterModule_nav(ofArray(["kurslop", `${track.Id}`]), 1, 1);
        },
        appearance: "primary",
        children: "Åpne",
        icon: (el_23 = ArrowRightRegular, createElement(el_23, {})),
    }))), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])));
}

export function ListTracks() {
    let elems_4, elems_1, elems_3;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const tracks = patternInput_1[0];
    const setTracks = patternInput_1[1];
    const patternInput_2 = reactApi.useState([]);
    const patternInput_3 = reactApi.useState(true);
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Task.GetMy());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "getMyTasksError", "Noe gikk galt", "Kunne ikke hente mine gjennomførte oppgaver", undefined);
            }
            else {
                patternInput_2[1](res.fields[0]);
            }
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(ctx.User.IsAdmin ? Track.GetAll() : Track.GetAllEnabled());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "getTracksError", "Kunne ikke hente kursløp", "Noe gikk galt", undefined);
            }
            else {
                setTracks(res_1.fields[0]);
            }
            patternInput_3[1](false);
            return res_1;
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Kursløp",
        })), (el_2 = Caption1, createElement(el_2, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: "Alle kursløp",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (ctx.User.IsAdmin ? singleton(createElement(CreateTrackDialog, {
            callback: (newTrack) => {
                setTracks(append_1([newTrack], tracks));
            },
        })) : empty())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 5 + "px ",
    }], (elems_3 = toList(delay(() => (patternInput_3[0] ? map((_arg_1) => {
        let elems_2, el_4;
        const el_6 = Skeleton;
        return createElement(el_6, createObj(ofArray([["style", {
            width: 100 + "%",
        }], (elems_2 = [(el_4 = SkeletonItem, createElement(el_4, {
            size: 128,
            shape: "rectangle",
            animation: "wave",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
    }, toList(rangeDouble(1, 1, 6))) : map_1((track) => TrackCard(track, patternInput_2[0]), sortBy((_arg_2) => _arg_2.Name, tracks, {
        Compare: comparePrimitives,
    }))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

//# sourceMappingURL=ListTracks.jsx.map
